import React, { Component } from 'react';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import { connect } from 'react-redux';
import cx from 'classnames';
import Form from 'react-bootstrap/Form';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import withStyles from 'isomorphic-style-loader/withStyles';
import { injectIntl } from 'react-intl';

import Link from '../../../Link/Link'

import Loader from '../../../Common/Loader/Loader';

import messages from '../../../../locale/messages';

import validate from './validate';
import onSubmit from './submit';

import s from './SmsForm.css';
import bt from '../../../../components/commonStyle.css';

export class SmsForm extends Component {

	renderField = ({ input, label, type, meta: { touched, error }, labelClass, fieldClass, placeholder, maxLength }) => {
		const { formatMessage } = this.props.intl;
		return (
			<Form.Group>
				<label className={bt.labelText} >{label}</label>
				<Form.Control {...input} placeholder={placeholder} type={type} className={bt.formControlInput} maxLength={maxLength} />
				{touched && error && <span className={cx(bt.errorMessage, 'errorRTL')}>{formatMessage(error)}</span>}
			</Form.Group>
		)
	}

	render() {
		const { handleSubmit, loading, submitting, id } = this.props;
		const { formatMessage } = this.props.intl;

		return (
			<div className={cx('cardSection', s.widthInner, bt.space5, s.responsiveNoPadding)}>
				<h1 className={cx('textAlignRightRTL', s.headingTwo, 'textWhite')}>{formatMessage(messages.editSmsMethod)}</h1>
				<Row>
					<Col md={12} lg={12} sm={12} xs={12}>
						<Form className={s.fullWidth} onSubmit={handleSubmit(onSubmit)}>
							<Row>
								<Col lg={6} md={12} sm={12} xs={12} className={bt.space2}>
									<Form.Group className={s.formGroup}>
										<div>
											<Field
												name="accountId"
												type="text"
												placeholder={id == 1 ? formatMessage(messages.accountId) : formatMessage(messages.apiKey)}
												component={this.renderField}
												label={id == 1 ? formatMessage(messages.accountId) : formatMessage(messages.apiKey)}
												labelClass={bt.labelText}
												fieldClass={bt.formControlInput}
											/>
										</div>
									</Form.Group>
								</Col>
								<Col lg={6} md={12} sm={12} xs={12} className={bt.space2}>
									<Form.Group className={s.formGroup}>
										<div>
									<Field
												name="securityId"
												type="password"
												placeholder={id == 1 ? formatMessage(messages.secretId) : formatMessage(messages.secretKey)}
												component={this.renderField}
												label={id == 1 ? formatMessage(messages.secretId) : formatMessage(messages.secretKey)}
												labelClass={bt.labelText}
												fieldClass={bt.formControlInput}
											/>
										</div>
									</Form.Group>
								</Col>
							</Row>
							<Row>
								<Col lg={6} md={12} sm={12} xs={12} className={bt.space2}>
									<Form.Group className={s.formGroup}>
										<div >
											<Field
												name="phoneNumber"
												type="text"
												placeholder={formatMessage(messages.senderId)}
												component={this.renderField}
												label={formatMessage(messages.senderId)}
												fieldClass={cx(s.formControlInput, s.inputRadius, 'inputRadiusRTL')}
											/>
										</div>
									</Form.Group>
								</Col>
							</Row>
							<div class="clearfix"></div>
							<div className={cx(bt.textAlignRight, bt.spaceTop3, 'textAlignLeftRTL', 'loadingBtnRTL')}>
								<Form.Group className={s.formGroup}>
									<div className={s.displayInlineBlock}>
										<Loader
											type={"button"}
											label={formatMessage(messages.update)}
											show={loading}
											buttonType={'submit'}
											className={cx(bt.btnPrimary)}
											disabled={submitting || loading}
											isSuffix={true}
										/>
									</div>
									<Link to={"/siteadmin/sms-methods"} className={cx(s.backBtn, bt.btnSecondary, 'backBtnRTL', s.displayInlineBlock)} >{formatMessage(messages.goBack)}</Link>
								</Form.Group>
							</div>
						</Form>
					</Col>
				</Row>
			</div>
		)
	}
}

SmsForm = reduxForm({
	form: 'SmsForm',
	onSubmit,
	validate
})(SmsForm);

const selector = formValueSelector('SmsForm');
const mapState = state => ({
	id: selector(state, 'id'),
	loading: state.loader.UpdateSmsMethod,
});

const mapDispatch = {};

export default injectIntl(withStyles(s, bt)(connect(mapState, mapDispatch)(SmsForm)));
